import React, { useState } from "react";
import { DialogBox } from "../../../../components/Elements/DialogBox";
import CustomSelect from "../../../../components/Elements/Select/CustomSelect";
import { Button, Input, Radio } from "antd";
import CustomButton from "../../../../components/Elements/Buttons/CustomButtons";

const formList = [
  { label: "Single Select", value: "single-select" },
  { label: "Multiple Select", value: "multi-select" },
  { label: "Date", value: "date" },
  { label: "Date Time", value: "date-time" },
  { label: "Free text", value: "free-text" },
  { label: "Dropdown", value: "dropdown" },
  { label: "Numeric", value: "Numeric" },
];

const AddQuestion = ({ onOpen, onClose }) => {
  const [questions, setQuestions] = useState([
    {
      questiontype: null,
      questionText: "",
      questionGuidance: "",
      emissionFactor: null,
    },
  ]);

  const [errorMessages, setErrorMessages] = useState([]);

  const handleSelectForm = (index, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index].questiontype = value;
    setQuestions(updatedQuestions);
  };

  const handleChange = (index, field, value) => {
    const updatedQuestions = [...questions];
    updatedQuestions[index][field] = value;
    setQuestions(updatedQuestions);
  };

  const addMoreQuestion = () => {
    setQuestions([
      ...questions,
      {
        questiontype: null,
        questionText: "",
        questionGuidance: "",
        emissionFactor: null,
      },
    ]);
  };

  const handleSave = () => {
    let errors = [];
    let isValid = true;

    const newErrors = questions.map((q) => {
      let error = {};
      if (!q.questiontype) error.questiontype = "Question Type is required.";
      if (!q.questionText.trim())
        error.questionText = "Question Text is required.";
      if (!q.questionGuidance.trim())
        error.questionGuidance = "Question Guidance is required.";
      if (q.emissionFactor === null)
        error.emissionFactor =
          "Please select an option for 'Has Emission Factor'.";

      if (Object.keys(error).length > 0) isValid = false;
      return error;
    });

    setErrorMessages(newErrors);

    if (isValid) {
      console.log("Saved Data:", questions);
    }
  };

  const handleCancel = () => {
    setQuestions([
      {
        questiontype: null,
        questionText: "",
        questionGuidance: "",
        emissionFactor: null,
      },
    ]);
    setErrorMessages([]);
    onClose();
  };

  return (
    <div className="flex justify-center my-4">
      <DialogBox open={onOpen} onCancel={onClose} width="90%" maxWidth="750px">
        <div>
          <h3 className="text-2xl">Add Question</h3>
          <hr className="py-4" style={{ color: "1px solid #ebedf3" }} />
          {questions.map((q, index) => (
            <div
              key={index}
              style={{
                border: "1px solid #ebedf3",
                borderRadius: "10px",
                padding: "20px",
                marginBottom: "20px",
              }}
            >
              {/* Question type Selection */}
              <label className="mb-2 block">Question Type</label>
              <CustomSelect
                options={formList}
                mode="single"
                placeholder="Please Select"
                height="40px"
                value={q.questiontype}
                onChange={(value) => handleSelectForm(index, value)}
              />
              {errorMessages[index]?.questiontype && (
                <div className="text-red-500 text-sm mt-1">
                  {errorMessages[index].questiontype}
                </div>
              )}

              {/* Question Text or Label */}
              <div className="mt-4">
                <label className="mb-2 block">Question Text</label>
                <Input
                  value={q.questionText}
                  onChange={(e) =>
                    handleChange(index, "questionText", e.target.value)
                  }
                  placeholder="Enter question"
                  className="h-14 rounded-lg"
                />
                {errorMessages[index]?.questionText && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMessages[index].questionText}
                  </div>
                )}
              </div>

              {/* Question Guidance */}
              <div className="mt-4">
                <label className="mb-2 block">Question Guidance</label>
                <Input
                  value={q.questionGuidance}
                  onChange={(e) =>
                    handleChange(index, "questionGuidance", e.target.value)
                  }
                  placeholder="Enter guidance"
                  className="h-14 rounded-lg"
                />
                {errorMessages[index]?.questionGuidance && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMessages[index].questionGuidance}
                  </div>
                )}
              </div>

              {/* Emission Factor (Yes/No) */}
              <div className="mt-4">
                <label className="mb-2 block">Has Emission Factor*</label>
                <Radio.Group
                  onChange={(e) =>
                    handleChange(index, "emissionFactor", e.target.value)
                  }
                  value={q.emissionFactor}
                >
                  <Radio value="yes">Yes</Radio>
                  <Radio value="no">No</Radio>
                </Radio.Group>
                {errorMessages[index]?.emissionFactor && (
                  <div className="text-red-500 text-sm mt-1">
                    {errorMessages[index].emissionFactor}
                  </div>
                )}
              </div>

              {/* + Add More Question Button */}
              {/* <div className="flex justify-start  mt-6">
                <button
                  onClick={addMoreQuestion}
                  style={{
                    color: "#088F8F",
                    background: "#e7fefe",
                  }}
                  className="  px-4 py-2 rounded-lg"
                >
                  + Add More Question
                </button>
              </div> */}
            </div>
          ))}
          {/* Buttons Section */}
          <div className="flex justify-center gap-4 py-6">
            <CustomButton
              buttonType="primary"
              variant="cancel"
              buttonText="Cancel"
              className="text-sm px-6 py-2 rounded-lg"
              onClick={handleCancel}
            />
            <CustomButton
              buttonType="primary"
              variant="ok"
              buttonText="Save"
              className=" text-sm px-6 py-2 rounded-lg"
              onClick={handleSave}
            />
          </div>
        </div>
      </DialogBox>
    </div>
  );
};

export default AddQuestion;
